import _ from "lodash";
import reportFiltersResolvers from "./report-filters-resolvers";

export default _.merge(reportFiltersResolvers);
